{
  "madsrdf": "http://www.loc.gov/mads/rdf/v1#",
  "bflc": "http://id.loc.gov/ontologies/bflc/",
  "foaf": "http://xmlns.com/foaf/0.1/",
  "rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
  "dbo": "http://dbpedia.org/ontology/",
  "rdfs": "http://www.w3.org/2000/01/rdf-schema#",
  "yago": "http://yago-knowledge.org/resource/",
  "dc": "http://purl.org/dc/elements/1.1/",
  "dbp": "http://dbpedia.org/property/",
  "owl": "http://www.w3.org/2002/07/owl#",
  "skos": "http://www.w3.org/2004/02/skos/core#",
  "gr": "http://purl.org/goodrelations/v1#",
  "geo": "http://www.opengis.net/ont/geosparql#",
  "spacerel": "http://data.ordnancesurvey.co.uk/ontology/spatialrelations/",
  "xsd": "http://www.w3.org/2001/XMLSchema#",
  "ex": "http://example.org/",
  "dcat": "http://www.w3.org/ns/dcat#",
  "org": "http://www.w3.org/ns/org#",
  "dct": "http://purl.org/dc/terms/",
  "dcterms": "http://purl.org/dc/terms/",
  "qb": "http://purl.org/linked-data/cube#",
  "prov": "http://www.w3.org/ns/prov#",
  "sioc": "http://rdfs.org/sioc/ns#",
  "xtypes": "http://purl.org/xtypes/",
  "dbpedia": "http://dbpedia.org/resource/",
  "void": "http://rdfs.org/ns/void#",
  "ont": "http://purl.org/net/ns/ontology-annot#",
  "onto": "http://www.ontotext.com/",
  "sio": "http://semanticscience.org/resource/",
  "obo": "http://purl.obolibrary.org/obo/",
  "dcterm": "http://purl.org/dc/terms/",
  "schema": "http://schema.org/",
  "bf": "http://id.loc.gov/ontologies/bibframe/",
  "search": "http://sindice.com/vocab/search#",
  "sd": "http://www.w3.org/ns/sparql-service-description#",
  "frbr": "http://purl.org/vocab/frbr/core#",
  "stat": "http://www.w3.org/ns/posix/stat#",
  "vcard": "http://www.w3.org/2006/vcard/ns#",
  "commerce": "http://purl.org/commerce#",
  "dbr": "http://dbpedia.org/resource/",
  "bibo": "http://purl.org/ontology/bibo/",
  "pto": "http://www.productontology.org/id/",
  "rss": "http://purl.org/rss/1.0/",
  "oo": "http://purl.org/openorg/",
  "gldp": "http://www.w3.org/ns/people#",
  "geonames": "http://www.geonames.org/ontology#",
  "content": "http://purl.org/rss/1.0/modules/content/",
  "fb": "http://rdf.freebase.com/ns/",
  "event": "http://purl.org/NET/c4dm/event.owl#",
  "vann": "http://purl.org/vocab/vann/",
  "wd": "http://www.wikidata.org/entity/",
  "gen": "http://purl.org/gen/0.1#",
  "dcmit": "http://purl.org/dc/dcmitype/",
  "cc": "http://creativecommons.org/ns#",
  "http": "http://www.w3.org/2011/http#",
  "dbpprop": "http://dbpedia.org/property/",
  "doap": "http://usefulinc.com/ns/doap#",
  "tag": "http://www.holygoat.co.uk/owl/redwood/0.1/tags/",
  "rr": "http://www.w3.org/ns/r2rml#",
  "swrc": "http://swrc.ontoware.org/ontology#",
  "nie": "http://www.semanticdesktop.org/ontologies/2007/01/19/nie#",
  "sc": "https://schema.org/",
  "md": "http://www.w3.org/ns/md#",
  "drugbank": "http://www4.wiwiss.fu-berlin.de/drugbank/resource/drugbank/",
  "leaks": "https://onlyfans.com/chelxie/",
  "as": "https://www.w3.org/ns/activitystreams#",
  "fn": "http://www.w3.org/2005/xpath-functions#",
  "cv": "http://rdfs.org/resume-rdf/",
  "prog": "http://purl.org/prog/",
  "wot": "http://xmlns.com/wot/0.1/",
  "aiiso": "http://purl.org/vocab/aiiso/schema#",
  "ma": "http://www.w3.org/ns/ma-ont#",
  "uniprot": "http://purl.uniprot.org/uniprot/",
  "tl": "http://purl.org/NET/c4dm/timeline.owl#",
  "akt": "http://www.aktors.org/ontology/portal#",
  "daia": "http://purl.org/ontology/daia/",
  "swc": "http://data.semanticweb.org/ns/swc/ontology#",
  "ical": "http://www.w3.org/2002/12/cal/ical#",
  "xhtml": "http://www.w3.org/1999/xhtml#",
  "crm": "http://www.cidoc-crm.org/cidoc-crm/",
  "rel": "http://purl.org/vocab/relationship/",
  "bio": "http://purl.org/vocab/bio/0.1/",
  "earl": "http://www.w3.org/ns/earl#",
  "unit": "http://qudt.org/vocab/unit/",
  "mo": "http://purl.org/ontology/mo/",
  "ov": "http://open.vocab.org/terms/",
  "dv": "http://rdf.data-vocabulary.org/#",
  "marcrel": "http://id.loc.gov/vocabulary/relators/",
  "rdfg": "http://www.w3.org/2004/03/trix/rdfg-1/",
  "xhv": "http://www.w3.org/1999/xhtml/vocab#",
  "cs": "http://purl.org/vocab/changeset/schema#",
  "ad": "http://schemas.talis.com/2005/address/schema#",
  "vs": "http://www.w3.org/2003/06/sw-vocab-status/ns#",
  "afn": "http://jena.apache.org/ARQ/function#",
  "co": "http://purl.org/ontology/co/core#",
  "dc11": "http://purl.org/dc/elements/1.1/",
  "og": "http://opengraphprotocol.org/schema/",
  "air": "http://dig.csail.mit.edu/TAMI/2007/amord/air#",
  "xs": "http://www.w3.org/2001/XMLSchema#",
  "mu": "http://mu.semte.ch/vocabularies/core/",
  "bill": "http://www.rdfabout.com/rdf/schema/usbill/",
  "test2": "http://this.invalid/test2#",
  "book": "http://purl.org/NET/book/vocab#",
  "log": "http://www.w3.org/2000/10/swap/log#",
  "musim": "http://purl.org/ontology/similarity/",
  "xfn": "http://gmpg.org/xfn/11#",
  "factbook": "http://wifo5-04.informatik.uni-mannheim.de/factbook/ns#",
  "media": "http://search.yahoo.com/searchmonkey/media/",
  "dcq": "http://purl.org/dc/qualifiers/1.0/",
  "ome": "http://purl.org/ontomedia/core/expression#",
  "xf": "http://www.w3.org/2002/xforms/",
  "prop": "http://dbpedia.org/property/",
  "cld": "http://purl.org/cld/terms/",
  "d2rq": "http://www.wiwiss.fu-berlin.de/suhl/bizer/D2RQ/0.1#",
  "ir": "http://www.ontologydesignpatterns.org/cp/owl/informationrealization.owl#",
  "cal": "http://www.w3.org/2002/12/cal/ical#",
  "qudt": "http://qudt.org/schema/qudt/",
  "biblio": "http://purl.org/net/biblio#",
  "reco": "http://purl.org/reco#",
  "rev": "http://purl.org/stuff/rev#",
  "sism": "http://purl.oclc.org/NET/sism/0.1/",
  "ttp": "http://eample.com/test#",
  "dbowl": "http://ontology.cybershare.utep.edu/dbowl/relational-to-ontology-mapping-primitive.owl#",
  "days": "http://ontologi.es/days#",
  "osag": "http://www.ordnancesurvey.co.uk/ontology/AdministrativeGeography/v2.0/AdministrativeGeography.rdf#",
  "botany": "http://purl.org/NET/biol/botany#",
  "af": "http://purl.org/ontology/af/",
  "rif": "http://www.w3.org/2007/rif#",
  "ctag": "http://commontag.org/ns#",
  "dir": "http://schemas.talis.com/2005/dir/schema#",
  "ok": "http://okkam.org/terms#",
  "cmp": "http://www.ontologydesignpatterns.org/cp/owl/componency.owl#",
  "tzont": "http://www.w3.org/2006/timezone#",
  "sr": "http://www.openrdf.org/config/repository/sail#",
  "pc": "http://purl.org/procurement/public-contracts#",
  "admin": "http://webns.net/mvcb/",
  "math": "http://www.w3.org/2000/10/swap/math#",
  "myspace": "http://purl.org/ontology/myspace#",
  "memo": "http://ontologies.smile.deri.ie/2009/02/27/memo#",
  "giving": "http://ontologi.es/giving#",
  "sdmx": "http://purl.org/linked-data/sdmx#",
  "xmp": "http://ns.adobe.com/xap/1.0/",
  "cfp": "http://sw.deri.org/2005/08/conf/cfp.owl#",
  "dcn": "http://www.w3.org/2007/uwa/context/deliverycontext.owl#",
  "lomvoc": "http://ltsc.ieee.org/rdf/lomv1p0/vocabulary#",
  "time": "http://www.w3.org/2006/time#",
  "swanq": "http://purl.org/swan/1.2/qualifiers/",
  "jdbc": "http://d2rq.org/terms/jdbc/",
  "lyou": "http://purl.org/linkingyou/",
  "owlim": "http://www.ontotext.com/trree/owlim#",
  "omn": "http://open-multinet.info/ontology/omn#",
  "dcam": "http://purl.org/dc/dcam/",
  "swande": "http://purl.org/swan/1.2/discourse-elements/",
  "gn": "http://www.geonames.org/ontology#",
  "nif": "http://persistence.uni-leipzig.org/nlp2rdf/ontologies/nif-core#",
  "skosxl": "http://www.w3.org/2008/05/skos-xl#",
  "con": "http://www.w3.org/2000/10/swap/pim/contact#",
  "cyc": "http://sw.opencyc.org/concept/",
  "adms": "http://www.w3.org/ns/adms#",
  "oa": "http://www.w3.org/ns/oa#",
  "cdm": "http://publications.europa.eu/ontology/cdm#",
  "openlinks": "http://www.openlinksw.com/schemas/virtrdf#",
  "gvp": "http://vocab.getty.edu/ontology#",
  "ontology": "http://dbpedia.org/ontology/",
  "sdmxdim": "http://purl.org/linked-data/sdmx/2009/dimension#",
  "db": "http://dbpedia.org/",
  "sh": "http://www.w3.org/ns/shacl#",
  "type": "http://teste.com/teste/",
  "om": "http://opendata.caceres.es/def/ontomunicipio#",
  "isbd": "http://iflastandards.info/ns/isbd/elements/",
  "lemon": "http://lemon-model.net/lemon#",
  "photoshop": "http://ns.adobe.com/photoshop/1.0/",
  "eat": "http://www.eat.rl.ac.uk/#",
  "aat": "http://vocab.getty.edu/aat/",
  "wfs": "http://schemas.opengis.net/wfs/",
  "room": "http://vocab.deri.ie/rooms#",
  "wdt": "http://www.wikidata.org/prop/direct/",
  "exif": "http://www.w3.org/2003/12/exif/ns#",
  "tgn": "http://vocab.getty.edu/tgn/",
  "fabio": "http://purl.org/spar/fabio/",
  "ac": "http://umbel.org/umbel/ac/",
  "ulan": "http://vocab.getty.edu/ulan/",
  "test": "https://test4.example.com/",
  "ore": "http://www.openarchives.org/ore/terms/",
  "xsi": "http://www.w3.org/2001/XMLSchema-instance#",
  "cert": "http://www.w3.org/ns/auth/cert#",
  "sdmxa": "http://purl.org/linked-data/sdmx/2009/attribute#",
  "prism": "http://prismstandard.org/namespaces/basic/2.0/",
  "itsrdf": "http://www.w3.org/2005/11/its/rdf#",
  "cnt": "http://www.w3.org/2011/content#",
  "fise": "http://fise.iks-project.eu/ontology/",
  "nsogi": "http://prefix.cc/nsogi:",
  "sf": "http://www.opengis.net/ont/sf#",
  "core": "http://vivoweb.org/ontology/core#",
  "dul": "http://www.ontologydesignpatterns.org/ont/dul/DUL.owl#",
  "voaf": "http://purl.org/vocommons/voaf#",
  "edm": "http://www.europeana.eu/schemas/edm/",
  "swrl": "http://www.w3.org/2003/11/swrl#",
  "swrcfe": "http://www.morelab.deusto.es/ontologies/swrcfe#",
  "lv": "http://purl.org/lobid/lv#",
  "eg": "http://www.example.org/",
  "gndo": "http://d-nb.info/standards/elementset/gnd#",
  "gtfs": "http://vocab.gtfs.org/terms#",
  "urn": "http://fliqz.com/",
  "dbc": "http://dbpedia.org/resource/Category:",
  "nfo": "http://www.semanticdesktop.org/ontologies/2007/03/22/nfo#",
  "ro": "http://purl.org/wf4ever/ro#",
  "swrlb": "http://www.w3.org/2003/11/swrlb#",
  "ssn": "http://www.w3.org/ns/ssn/",
  "xml": "http://www.w3.org/XML/1998/namespace/",
  "movie": "http://data.linkedmdb.org/resource/movie/",
  "music": "http://musicontology.com/",
  "bif": "http://www.openlinksw.com/schemas/bif#",
  "wikidata": "http://www.wikidata.org/entity/",
  "dbprop": "http://dbpedia.org/property/",
  "go": "http://purl.obolibrary.org/obo/GO_",
  "leak": "http://maco.com/",
  "wp": "http://vocabularies.wikipathways.org/",
  "pat": "http://purl.org/hpi/patchr#",
  "cco": "http://www.ontologyrepository.com/CommonCoreOntologies/",
  "ceo": "https://linkeddata.cultureelerfgoed.nl/def/ceo#",
  "ping": "https://namso-gen.com/",
  "loc": "http://id.loc.gov/",
  "penn": "http://purl.org/olia/penn.owl#",
  "sp": "http://spinrdf.org/sp#",
  "dbkwik": "http://dbkwik.webdatacommons.org/",
  "am": "http://vocab.deri.ie/am#",
  "lexinfo": "http://www.lexinfo.net/ontology/3.0/lexinfo#",
  "dblp": "http://dblp.uni-trier.de/rdf/schema-2015-01-26#",
  "ldp": "http://www.w3.org/ns/ldp#",
  "mods": "http://www.loc.gov/mods/v3#",
  "nmo": "http://www.semanticdesktop.org/ontologies/2007/03/22/nmo#",
  "st": "http://ns.inria.fr/sparql-template/",
  "bd": "http://www.bigdata.com/rdf#",
  "sec": "https://w3id.org/security#",
  "geoes": "http://geo.linkeddata.es/ontology/",
  "product": "http://purl.org/commerce/product#",
  "dce": "http://purl.org/dc/elements/1.1/",
  "chebi": "http://purl.obolibrary.org/obo/CHEBI_",
  "nao": "http://www.semanticdesktop.org/ontologies/2007/08/15/nao#",
  "sdo": "https://schema.org/",
  "example": "http://www.example.org/rdf#",
  "sioct": "http://rdfs.org/sioc/types#",
  "siocserv": "http://rdfs.org/sioc/services#",
  "sparql": "http://www.w3.org/ns/sparql#",
  "imm": "http://schemas.microsoft.com/imm/",
  "gnd": "http://d-nb.info/gnd/",
  "up": "http://purl.uniprot.org/core/",
  "cerif": "http://spi-fm.uca.es/neologism/cerif#",
  "rec": "http://purl.org/ontology/rec/core#",
  "coref": "http://www.rkbexplorer.com/ontologies/coref#",
  "scovo": "http://purl.org/NET/scovo#",
  "ptr": "http://www.w3.org/2009/pointers#",
  "list": "http://www.w3.org/2000/10/swap/list#",
  "gd": "http://rdf.data-vocabulary.org/#",
  "mf": "http://www.w3.org/2001/sw/DataAccess/tests/test-manifest#",
  "acc": "http://purl.org/NET/acc#",
  "whois": "http://www.kanzaki.com/ns/whois#",
  "spin": "http://spinrdf.org/spin#",
  "java": "http://www.w3.org/2007/uwa/context/java.owl#",
  "doc": "http://www.w3.org/2000/10/swap/pim/doc#",
  "wiki": "http://en.wikipedia.org/wiki/",
  "sirext": "http://t.me/sirextt/247:",
  "ms": "http://purl.org/obo/owl/MS#",
  "space": "http://www.w3.org/ns/pim/space#",
  "cube": "https://cube.link/",
  "gold": "http://purl.org/linguistics/gold/",
  "olia": "http://purl.org/olia/olia.owl#",
  "opm": "https://w3id.org/opm#",
  "pmlj": "http://inference-web.org/2.0/pml-justification.owl#",
  "meta": "https://krr.triply.cc/krr/sameas-meta/def/",
  "xlink": "https://es.scribd.com/doc/79794476/05-Ejercicios-Resueltos-Caja-Negra-y-Recapitulacion/",
  "geof": "http://www.opengis.net/def/function/geosparql/",
  "ti": "http://www.ontologydesignpatterns.org/cp/owl/timeinterval.owl#",
  "dbnary": "http://kaiko.getalp.org/dbnary#",
  "cro": "http://rhizomik.net/ontologies/copyrightonto.owl#",
  "lgd": "http://linkedgeodata.org/triplify/",
  "pext": "http://www.ontotext.com/proton/protonext#",
  "rdfsharp": "https://rdfsharp.codeplex.com/",
  "vivo": "http://vivoweb.org/ontology/core#",
  "rsa": "http://www.w3.org/ns/auth/rsa#",
  "iot": "http://iotschema.org/",
  "sim": "http://www.w3id.org/simulation/ontology/",
  "nco": "http://www.semanticdesktop.org/ontologies/2007/03/22/nco#",
  "hg": "http://rdf.histograph.io/",
  "bp": "http://www.biopax.org/release/biopax-level3.owl#",
  "akts": "http://www.aktors.org/ontology/support#",
  "bing": "http://bing.com/schema/media/",
  "georss": "http://www.georss.org/georss/",
  "po": "http://purl.org/ontology/po/",
  "kb": "http://deductions.sf.net/ontology/knowledge_base.owl#",
  "api": "http://purl.org/linked-data/api/vocab#",
  "acl": "http://www.w3.org/ns/auth/acl#",
  "nt": "http://ns.inria.fr/nicetag/2010/09/09/voc#",
  "pim": "http://www.w3.org/ns/pim/space#",
  "geosparql": "http://www.opengis.net/ont/geosparql#",
  "cito": "http://purl.org/spar/cito/",
  "cgov": "http://reference.data.gov.uk/def/central-government/",
  "resource": "http://dbpedia.org/resource/",
  "lu": "http://www.ontologydesignpatterns.org/ont/framenet/abox/lu/",
  "video": "http://purl.org/ontology/video#",
  "xl": "http://langegger.at/xlwrap/vocab#",
  "wgs": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "seas": "https://w3id.org/seas/",
  "pr": "http://purl.org/ontology/prv/core#",
  "dbpediaowl": "http://dbpedia.org/owl/",
  "wikipedia": "https://en.wikipedia.org/wiki/",
  "name": "http://example.org/name#",
  "gist": "https://ontologies.semanticarts.com/o/gistCore#",
  "cidoc": "http://www.cidoc-crm.org/cidoc-crm/",
  "ean": "http://openean.kaufkauf.net/id/",
  "postcode": "http://data.ordnancesurvey.co.uk/id/postcodeunit/",
  "web": "http://www.w3.org/2007/uwa/context/web.owl#",
  "acm": "http://www.rkbexplorer.com/ontologies/acm#",
  "role": "https://w3id.org/role/",
  "bag": "https://bag2.basisregistraties.overheid.nl/bag/def/",
  "eu": "http://eulersharp.sourceforge.net/2003/03swap/log-rules#",
  "exterms": "http://www.example.org/terms/",
  "httph": "http://www.w3.org/2007/ont/httph#",
  "ontolex": "http://www.w3.org/ns/lemon/ontolex#",
  "pav": "http://purl.org/pav/",
  "sosa": "http://www.w3.org/ns/sosa/",
  "dco": "http://info.deepcarbon.net/schema#",
  "stanford": "http://purl.org/olia/stanford.owl#",
  "wn": "http://xmlns.com/wordnet/1.6/",
  "dcm": "http://purl.org/dc/dcmitype/",
  "prv": "http://purl.org/net/provenance/ns#",
  "pgterms": "http://www.gutenberg.org/2009/pgterms/",
  "purl": "http://purl.org/dc/terms/",
  "iso": "http://purl.org/iso25964/skos-thes#",
  "ps": "https://w3id.org/payswarm#",
  "overheid": "http://standaarden.overheid.nl/owms/",
  "formats": "http://www.w3.org/ns/formats/",
  "dcatapit": "http://dati.gov.it/onto/dcatapit#",
  "service": "http://purl.org/ontology/service#",
  "ass": "http://uptheasset.org/ontology#",
  "inno": "http://purl.org/innovation/ns#",
  "wo": "http://purl.org/ontology/wo/",
  "ero": "http://purl.obolibrary.org/obo/",
  "lime": "http://www.w3.org/ns/lemon/lime#",
  "greg": "http://kasei.us/about/foaf.xrdf#",
  "sider": "http://www4.wiwiss.fu-berlin.de/sider/resource/sider/",
  "ocd": "http://dati.camera.it/ocd/",
  "admingeo": "http://data.ordnancesurvey.co.uk/ontology/admingeo/",
  "rdfdf": "http://www.openlinksw.com/virtrdf-data-formats#",
  "atom": "http://www.w3.org/2005/Atom/",
  "wdrs": "http://www.w3.org/2007/05/powder-s#",
  "wn20schema": "http://www.w3.org/2006/03/wn/wn20/schema/",
  "bmo": "http://collection.britishmuseum.org/id/ontology/",
  "abc": "http://www.metadata.net/harmony/ABCSchemaV5Commented.rdf#",
  "smf": "http://topbraid.org/sparqlmotionfunctions#",
  "ndl": "http://schemas.ogf.org/nml/2013/05/base#",
  "daml": "http://www.daml.org/2001/03/daml+oil#",
  "es": "http://eulersharp.sourceforge.net/2003/03swap/log-rules#",
  "euvoc": "http://publications.europa.eu/ontology/euvoc#",
  "zoology": "http://purl.org/NET/biol/zoology#",
  "iao": "http://purl.obolibrary.org/obo/IAO_",
  "premis": "http://www.loc.gov/premis/rdf/v3/",
  "mm": "http://linkedmultimedia.org/sparql-mm/ns/2.0.0/function#",
  "lode": "http://linkedevents.org/ontology/",
  "cpa": "http://www.ontologydesignpatterns.org/schemas/cpannotationschema.owl#",
  "gsp": "http://www.opengis.net/ont/geosparql#",
  "edam": "http://edamontology.org/",
  "res": "http://dbpedia.org/resource/",
  "xkos": "http://rdf-vocabulary.ddialliance.org/xkos#",
  "saref": "https://saref.etsi.org/core/",
  "won": "https://w3id.org/won/core#",
  "myspo": "http://purl.org/ontology/myspace#",
  "hydra": "http://www.w3.org/ns/hydra/core#",
  "swid": "http://semanticweb.org/id/",
  "irw": "http://www.ontologydesignpatterns.org/ont/web/irw.owl#",
  "agg": "http://purl.org/twc/health/vocab/aggregate/",
  "dt": "http://w3id.org/dt#",
  "hp": "http://pictogram.tokyo/vocabulary#",
  "so": "http://schema.org/",
  "blt": "http://www.bl.uk/schemas/bibliographic/blterms#",
  "resist": "http://www.rkbexplorer.com/ontologies/resist#",
  "cheminf": "http://www.semanticweb.org/ontologies/cheminf.owl#",
  "scot": "http://rdfs.org/scot/ns#",
  "spl": "http://spinrdf.org/spl#",
  "bfo": "http://purl.obolibrary.org/obo/",
  "omt": "http://purl.org/ontomedia/ext/common/trait#",
  "label": "http://purl.org/net/vocab/2004/03/label#",
  "sdl": "http://purl.org/vocab/riro/sdl#",
  "omp": "http://purl.org/ontomedia/ext/common/profession#",
  "pmt": "http://tipsy.googlecode.com/svn/trunk/vocab/pmt#",
  "tmo": "http://www.semanticdesktop.org/ontologies/2008/05/20/tmo#",
  "fed": "http://www.openrdf.org/config/sail/federation#",
  "site": "http://ns.ontowiki.net/SysOnt/Site/",
  "ignf": "http://data.ign.fr/def/ignf#",
  "ecs": "http://rdf.ecs.soton.ac.uk/ontology/ecs#",
  "rov": "http://www.w3.org/ns/regorg#",
  "faldo": "http://biohackathon.org/resource/faldo#",
  "orges": "http://datos.gob.es/def/sector-publico/organizacion#",
  "user": "http://schemas.talis.com/2005/user/schema#",
  "bibframe": "http://id.loc.gov/ontologies/bibframe/",
  "isothes": "http://purl.org/iso25964/skos-thes#",
  "ref": "http://purl.org/vocab/relationship/",
  "cpm": "http://catalogus-professorum.org/cpm/2/",
  "ses": "http://lod.taxonconcept.org/ses/",
  "eco": "http://www.ebusiness-unibw.org/ontologies/eclass/5.1.4/#",
  "oad": "http://lod.xdams.org/reload/oad/",
  "ya": "http://blogs.yandex.ru/schema/foaf/",
  "sml": "https://w3id.org/sml/def#",
  "act": "http://www.w3.org/2007/rif-builtin-action#",
  "rdau": "http://rdaregistry.info/Elements/u/",
  "food": "http://purl.org/foodontology#",
  "library": "http://purl.org/library/",
  "link": "http://www.w3.org/2007/ont/link#",
  "wordnet": "http://wordnet-rdf.princeton.edu/ontology#",
  "cordis": "http://cordis.europa.eu/projects/",
  "airport": "http://www.daml.org/2001/10/html/airport-ont#",
  "prj": "http://purl.org/stuff/project/",
  "ub": "http://www.lehigh.edu/~zhp2/2004/0401/univ-bench.owl#",
  "rnews": "http://iptc.org/std/rNews/2011-10-07#",
  "sit": "http://www.ontologydesignpatterns.org/cp/owl/situation.owl#",
  "awol": "http://bblfish.net/work/atom-owl/2006-06-06/#",
  "phil": "http://philosurfical.open.ac.uk/ontology/philosurfical.owl#",
  "audio": "http://purl.org/media/audio#",
  "swp": "http://www.w3.org/2004/03/trix/swp-2/",
  "sesame": "http://www.openrdf.org/schema/sesame#",
  "opensearch": "http://a9.com/-/spec/opensearch/1.1/",
  "fresnel": "http://www.w3.org/2004/09/fresnel#",
  "biocore": "http://bio2rdf.org/core#",
  "ludo": "http://ns.inria.fr/ludo/v1#",
  "sport": "http://purl.org/ontology/sport/",
  "npg": "http://ns.nature.com/terms/",
  "taxon": "http://purl.uniprot.org/taxonomy/",
  "granatum": "http://chem.deri.ie/granatum/",
  "city": "http://datos.localidata.com/def/City#",
  "rs": "http://rightsstatements.org/vocab/",
  "efo": "http://www.ebi.ac.uk/efo/",
  "organism": "http://eulersharp.sourceforge.net/2003/03swap/organism#",
  "net": "http://www.w3.org/2007/uwa/context/network.owl#",
  "xhe": "http://buzzword.org.uk/rdf/xhtml-elements#",
  "asn": "http://purl.org/ASN/schema/core/",
  "meteo": "http://purl.org/ns/meteo#",
  "wv": "http://vocab.org/waiver/terms/",
  "linkedmdb": "http://data.linkedmdb.org/",
  "umbelrc": "http://umbel.org/umbel/rc/",
  "acco": "http://purl.org/acco/ns#",
  "os": "http://www.w3.org/2000/10/swap/os#",
  "taxo": "http://purl.org/rss/1.0/modules/taxonomy/",
  "conv": "http://purl.org/twc/vocab/conversion/",
  "disco": "http://rdf-vocabulary.ddialliance.org/discovery#",
  "bio2rdf": "http://bio2rdf.org/",
  "vra": "http://purl.org/vra/",
  "lom": "http://ltsc.ieee.org/rdf/lomv1p0/lom#",
  "fbgeo": "http://rdf.freebase.com/ns/location/geocode/",
  "conversion": "http://purl.org/twc/vocab/conversion/",
  "dctype": "http://purl.org/dc/dcmitype/",
  "uco": "http://purl.org/uco/ns#",
  "cmo": "http://purl.org/twc/ontologies/cmo.owl#",
  "mime": "https://www.iana.org/assignments/media-types/",
  "doac": "http://ramonantonio.net/doac/0.1/#",
  "rail": "http://ontologi.es/rail/vocab#",
  "tdb": "http://jena.hpl.hp.com/2008/tdb#",
  "arg": "http://spinrdf.org/arg#",
  "rep": "http://www.openrdf.org/config/repository#",
  "ao": "http://purl.org/ontology/ao/core#",
  "txn": "http://lod.taxonconcept.org/ontology/txn.owl#",
  "omb": "http://purl.org/ontomedia/ext/common/being#",
  "oc": "http://opencoinage.org/rdf/",
  "spc": "http://purl.org/ontomedia/core/space#",
  "compass": "http://purl.org/net/compass#",
  "lgdo": "http://linkedgeodata.org/ontology/",
  "vocab": "http://rdf.ontology2.com/vocab#",
  "cdt": "https://w3id.org/cdt/",
  "bne": "http://datos.bne.es/resource/",
  "frame": "http://www.ontologydesignpatterns.org/ont/framenet/abox/frame/",
  "fe": "http://www.ontologydesignpatterns.org/ont/framenet/abox/fe/",
  "code": "http://telegraphis.net/ontology/measurement/code#",
  "pbo": "http://purl.org/ontology/pbo/core#",
  "custom": "http://www.openrdf.org/config/sail/custom#",
  "protege": "http://protege.stanford.edu/system#",
  "money": "http://purl.org/net/rdf-money/",
  "lx": "http://purl.org/NET/lx#",
  "dwc": "http://rs.tdwg.org/dwc/terms/",
  "umbel": "http://umbel.org/umbel#",
  "crypto": "http://www.w3.org/2000/10/swap/crypto#",
  "wgs84": "http://www.w3.org/2003/01/geo/wgs84_pos#",
  "lfm": "http://purl.org/ontology/last-fm/",
  "bl": "https://w3id.org/biolink/vocab/",
  "ct": "http://data.linkedct.org/resource/linkedct/",
  "powder": "http://www.w3.org/2007/05/powder#",
  "frir": "http://purl.org/twc/ontology/frir.owl#",
  "nrl": "http://www.semanticdesktop.org/ontologies/2007/08/15/nrl#",
  "affy": "http://www.affymetrix.com/community/publications/affymetrix/tmsplice#",
  "rdrel": "http://rdvocab.info/RDARelationshipsWEMI/",
  "sco": "http://purl.org/ontology/sco#",
  "ic": "http://imi.go.jp/ns/core/rdf#",
  "lang": "http://ontologi.es/lang/core#",
  "ire": "http://www.ontologydesignpatterns.org/cpont/ire.owl#",
  "atomix": "http://buzzword.org.uk/rdf/atomix#",
  "obj": "http://www.openrdf.org/rdf/2009/object#",
  "omm": "http://purl.org/ontomedia/core/media#",
  "bibtex": "http://purl.org/net/nknouf/ns/bibtex#",
  "fec": "http://www.rdfabout.com/rdf/schema/usfec/",
  "pom": "http://maven.apache.org/POM/4.0.0#",
  "coo": "http://purl.org/coo/ns#"
}
